// extracted by mini-css-extract-plugin
export var copyableField = "_k4-4";
export var customerBadge = "_k4-0";
export var customerInfoTitle = "_k4-2";
export var details = "_k4-1";
export var dropdownContainer = "_k4-5";
export var dropdownImage = "_k4-6";
export var editAssigneeForm = "_k4-a";
export var editButton = "_k4-3";
export var email = "_k4-7";
export var hidden = "_k4-d";
export var input = "_k4-8";
export var saveButton = "_k4-b";
export var shopifyIcon = "_k4-c";
export var suggestionBadge = "_k4-e";
export var suggestionText = "_k4-f";
export var username = "_k4-9";